import axios from "axios";
import type {
  TPost,
  CreatePostDTO,
  PostQueryParamsDTO,
  UpdatePostDTO,
  UnpublishPostDTO,
} from "./validators";
import { ApiError } from "./error";

const axiosInstance = axios.create({
  baseURL: "https://dev.to/api",
  headers: {
    "Content-Type": "application/json",
  },
});

const secureAxiosInstance = axiosInstance.create({
  headers: {
    "api-key": process.env.BUN_PUBLIC_DEV_API_KEY || "",
  },
});

export async function getPosts(input: PostQueryParamsDTO) {
  try {
    const result = await axiosInstance.get<TPost[]>("/articles", {
      params: {
        ...input,
      },
    });

    return result.data;
  } catch (error) {
    throw ApiError.from(error);
  }
}

export async function addPost(input: CreatePostDTO) {
  try {
    const result = await secureAxiosInstance.post<TPost>("/articles", {
      ...input,
    });

    return result.data;
  } catch (error) {
    throw ApiError.from(error);
  }
}

export async function updatePost(input: UpdatePostDTO) {
  try {
    const result = await secureAxiosInstance.put(`/articles/${input.id}`, {
      article: { ...input.article },
    });

    return result.data;
  } catch (error) {
    throw ApiError.from(error);
  }
}

export async function unpublishPost(input: UnpublishPostDTO) {
  try {
    const result = await secureAxiosInstance.put(
      `/articles/${input.id}/unpublish`,
      {},
      {
        params: { note: input.note || "" },
      },
    );

    return result.data;
  } catch (error) {
    throw ApiError.from(error);
  }
}
